import { render, staticRenderFns } from "./PageLeft.vue?vue&type=template&id=49ce0a4d&"
import script from "./PageLeft.vue?vue&type=script&lang=js&"
export * from "./PageLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports